export enum ReportType {
  SCHEDULED_WORKOUTS = "Scheduled Workouts",
  PAST_EXAMS = "Past Exams",
  WORKOUT_REQUESTS = "Workout Requests",
  WRONGFUL_WORKOUTS = "Wrongful Workouts"
}

export enum DateRangeType {
  TODAY = 0,
  NEXT_3_DAYS = 3,
  NEXT_7_DAYS = 7,
  LAST_7_DAYS = -7,
  LAST_30_DAYS = -30,
  LAST_45_DAYS = -45,
  LAST_60_DAYS = -60,
  CUSTOM = "CUSTOM"
}

export const getDateOptions = (reportType: ReportType): DateRangeType[] => {
  switch (reportType) {
    case ReportType.SCHEDULED_WORKOUTS:
      return [
        DateRangeType.TODAY,
        DateRangeType.NEXT_3_DAYS,
        DateRangeType.NEXT_7_DAYS,
        DateRangeType.CUSTOM
      ];
    default:
      return [
        DateRangeType.LAST_7_DAYS,
        DateRangeType.LAST_30_DAYS,
        DateRangeType.LAST_45_DAYS,
        DateRangeType.LAST_60_DAYS
      ];
  }
};

export const downloadFile = (
  fileContent: Uint8Array,
  fileName: string
): void => {
  const url = window.URL.createObjectURL(new Blob([fileContent]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.append(link);
  link.click();
  link.remove();
};
